export const queryKeyFactory = {
  listPatients: (clinicId: string, pendingUsers: boolean) => [
    'listPatients',
    'clinic',
    clinicId,
    'pendingUsers',
    pendingUsers
  ],
  listClinicians: (clinicId: string, pendingUsers: boolean) => [
    'listClinicians',
    'clinic',
    clinicId,
    'pendingUsers',
    pendingUsers
  ],
  listPatientsWithAssessmentStatus: (
    clinicId: string,
    pendingUsers: boolean
  ) => [
    'listPatientsWithAssessmentStatus',
    'clinic',
    clinicId,
    'pendingUsers',
    pendingUsers
  ],
  cgs: (patientId: string) => ['assessments', patientId, 'cgs'],
  pcs: (patientId: string) => ['assessments', patientId, 'pcs'],
  dhi: (patientId: string) => ['assessments', patientId, 'dhi'],
  promis: (patientId: string) => ['assessments', patientId, 'promis'],
  impact: (patientId: string) => ['assessments', patientId, 'impact'],
  concussions: (patientId: string) => [patientId, 'concussions'],
  invitation: {
    root: () => ['invitation'],
    link: (invitationId: string) => [
      ...queryKeyFactory.invitation.root(),
      invitationId,
      'link'
    ]
  },
  assessment: {
    pending: (patientId: string) => ['assessment', 'pending', patientId],
    overview: (patientId: string) => ['assessment', 'overview', patientId]
  },
  onboarding: (patientId: string) => ['onboarding', patientId],
  clinician: {
    data: (clinicianId: string) => ['clinician', 'data', clinicianId],
    clinicAdminData: (uid: string) => ['clinicAdminData', uid]
  },
  clinic: {
    __root__: (clinicId: string) => ['clinic', clinicId],
    basicInfo: (clinicId: string) => [
      ...queryKeyFactory.clinic.__root__(clinicId),
      'basicInfo'
    ],
    allInfo: (clinicId: string) => [
      ...queryKeyFactory.clinic.__root__(clinicId),
      'allInfo'
    ],
    productOptions: (clinicId: string) => [
      ...queryKeyFactory.clinic.__root__(clinicId),
      'productOptions'
    ],
    onboarding: {
      validate: (token: string) => ['onboardingTokenValidation', token]
    }
  },
  patient: {
    root: () => ['patient'],
    rootSingle: (patientId: string) => [
      ...queryKeyFactory.patient.root(),
      patientId
    ],
    assessmentLink: {
      root: (patientId: string) => [
        ...queryKeyFactory.patient.rootSingle(patientId),
        'assessmentLink'
      ],
      list: (patientId: string) => [
        ...queryKeyFactory.patient.assessmentLink.root(patientId),
        'list'
      ],
      token: (assessmentLinkId: string) => [
        ...queryKeyFactory.patient.assessmentLink.root('--'),
        'assessmentLink',
        assessmentLinkId
      ]
    }
  },
  integration: {
    root: () => ['root'],
    impact: {
      root: () => [...queryKeyFactory.integration.root(), 'impact'],
      isTokenValid: (token: string) => [
        ...queryKeyFactory.integration.impact.root(),
        'isTokenValid',
        token
      ],
      isInPilot: (id: string) => [
        ...queryKeyFactory.integration.impact.root(),
        'isInPilot',
        id
      ],
      decodedToken: (token: string) => [
        ...queryKeyFactory.integration.impact.root(),
        'decodedToken',
        token
      ],
      isAssignedToPatientWithPassportId: (passportId: string) => [
        ...queryKeyFactory.integration.impact.root(),
        'passportidassignment',
        passportId
      ]
    }
  }
};
